import type { ServiceCategoryInterface } from '@models/service/service-category.interface';

import { createAction, props } from '@ngrx/store';

export const loadAllServiceCategory = createAction('[ServiceCategory] Load All');
export const setAllServiceCategorySuccess = createAction(
  '[ServiceCategory] Set Success',
  props<{ servicesCategories: ServiceCategoryInterface[] }>()
);
export const setAllServiceCategoryFailed = createAction('[ServiceCategory] Set Failed');
